import React from 'react';
import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';
import NumberCompareTerminalMixin from './NumberCompareTerminalMixin';

const Age = createReactClass({
  displayName: 'Age',
  mixins: [BaseMixin, NumberCompareTerminalMixin],

  render: function() {
    return (
      <form className="form-inline">
        { this.renderTerminalName() }
        { this.renderRelOp() }
        { this.renderValue() }
      </form>
    );
  }
});

export default Age;
